import { baseUrl, handleResponse, handleError, PutOptions, GetHeaders } from "../../../../apis/common/ApiUtils";

const apiUrl = baseUrl + "travel/voucher";

export function getVoucherDetail(voucherId) {
    return fetch(`${apiUrl}/${voucherId}`, GetHeaders())
        .then(handleResponse)
        .catch(handleError);
}

export function getVoucherTransactions(voucherId) {
    return fetch(`${apiUrl}/${voucherId}/transactions`, GetHeaders())
        .then(handleResponse)
        .catch(handleError);
}

export function adjustVoucher(voucherId, adjustmentData) {
    return fetch(`${apiUrl}/${voucherId}/adjust`, PutOptions(adjustmentData))
        .then(handleResponse)
        .catch(handleError);
}

export function updateVoucher(voucherId, voucherData) {
    return fetch(`${apiUrl}/${voucherId}/update`, PutOptions(voucherData))
        .then(handleResponse)
        .catch(handleError);
}
